import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { Play } from 'lucide-react';

const extractVideoId = (url) => {
  const match = url.match(/(?:v=|\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
};

const TUTORIAL_DATA = {
  'EHR Tutorials': {
    subcategories: {
      'All': null,
      'Access & Login': [
        'https://www.youtube.com/watch?v=yqSGLIU75OI'
      ],
      'Dashboard': [
        'https://www.youtube.com/watch?v=Dj3CGmfMIO8'
      ],
      'Booking Appts': [
        'https://www.youtube.com/watch?v=rfyHIkjhZD0',
        'https://www.youtube.com/watch?v=rUTTL0KmrxI',
        'https://www.youtube.com/watch?v=MwfQhgRuHL0',
        'https://www.youtube.com/watch?v=KwnR8qtEsNU',
        'https://www.youtube.com/watch?v=MWFEWJy-fMg'
      ],
      'Managing Appts': [
        'https://www.youtube.com/watch?v=ktEz1t7en2A',
        'https://www.youtube.com/watch?v=6OhGXFNHDEw',
        'https://www.youtube.com/watch?v=WPZL-DLh81Y',
        'https://www.youtube.com/watch?v=glkvBbbyj_I'
      ],
      'Check-In / Check-Out': [
        'https://www.youtube.com/watch?v=pAtP-Lnylwg'
      ],
      'Charting': [
        'https://www.youtube.com/watch?v=DbugVlc7sJw',
        'https://www.youtube.com/watch?v=KSUTDsnNUP0',
        'https://www.youtube.com/watch?v=nQFa6YyCIqE',
        'https://www.youtube.com/watch?v=myYA6lXAzZM'
      ]
    }
  },
  'Billing Tutorials': {
    subcategories: {
      'All': null,
      'Charge Entry': [
        'https://www.youtube.com/watch?v=K-JhcDgOIIs',
        'https://www.youtube.com/watch?v=ADRGno17lQU',
        'https://www.youtube.com/watch?v=r2Ed1X1khYY',
        'https://www.youtube.com/watch?v=LOpW6KEHpbc',
        'https://www.youtube.com/watch?v=7t1OLtJtHEQ',
        'https://www.youtube.com/watch?v=CdPHqIGTyt4',
        'https://www.youtube.com/watch?v=tESl_8vtvJg',
        'https://www.youtube.com/watch?v=uW4LHMDcuXc',
        'https://www.youtube.com/watch?v=DU2V00WMCJQ',
        'https://www.youtube.com/watch?v=LVpqAog50ew',
        'https://www.youtube.com/watch?v=K1TJ1JvgzNI',
        'https://www.youtube.com/watch?v=dSnxIFiblGI',
        'https://www.youtube.com/watch?v=x2HJzmu4x2M',
        'https://www.youtube.com/watch?v=lbzsra_8m1c',
        'https://www.youtube.com/watch?v=6TZ1vkNq_3k',
        'https://www.youtube.com/watch?v=KL3WhcLH7Lk',
        'https://www.youtube.com/watch?v=CAo50TEx600',
        'https://www.youtube.com/watch?v=5Rv1rMJiF-Y',
        'https://www.youtube.com/watch?v=u7z1A0mGwSU',
        'https://www.youtube.com/watch?v=LngDFdvJviY',
        'https://www.youtube.com/watch?v=tvRkuQqp5u8',
        'https://www.youtube.com/watch?v=_cz7e5WlK9U',
        'https://www.youtube.com/watch?v=ruS8ElXXDGs',
        'https://www.youtube.com/watch?v=UNcJ6b8UMKw',
        'https://www.youtube.com/watch?v=PmUOAAIthhE'
      ],
      'Payment Posting': [
        'https://www.youtube.com/watch?v=cu3nQVZo-Wk',
        'https://www.youtube.com/watch?v=veUcksfgooY',
        'https://www.youtube.com/watch?v=SjPbx5OoxUQ',
        'https://www.youtube.com/watch?v=qPjDe_46huc',
        'https://www.youtube.com/watch?v=wSzpzpt_Xb4',
        'https://www.youtube.com/watch?v=5yB0HDInPWs',
        'https://www.youtube.com/watch?v=MSnbpWppY3s',
        'https://www.youtube.com/watch?v=-CnSxnyiJU4',
        'https://www.youtube.com/watch?v=pdCMG5o3FW8',
        'https://www.youtube.com/watch?v=mcbDH7sNUds',
        'https://www.youtube.com/watch?v=RYm63y-ZLbM',
        'https://www.youtube.com/watch?v=9bSMMLlnDJ0',
        'https://www.youtube.com/watch?v=h_PFr4Qcmvo',
        'https://www.youtube.com/watch?v=FYC7cn9i4oY',
        'https://www.youtube.com/watch?v=EAxAAYEJk_k',
        'https://www.youtube.com/watch?v=Ozy74GlVmRU',
        'https://www.youtube.com/watch?v=exEqYJjcfYQ',
        'https://www.youtube.com/watch?v=9Dx2rH5rp3M',
        'https://www.youtube.com/watch?v=-pDSEb8KwVg',
        'https://www.youtube.com/watch?v=zZKdlcuRpG4',
        'https://www.youtube.com/watch?v=9FVZ817MJYU',
        'https://www.youtube.com/watch?v=7eA2Z-dYiLc',
        'https://www.youtube.com/watch?v=iE3c1bV_PE0',
        'https://www.youtube.com/watch?v=OGwQ4n4FP4c',
        'https://www.youtube.com/watch?v=rcr54VSAu5s',
        'https://www.youtube.com/watch?v=r-R_7vgTOMo',
        'https://www.youtube.com/watch?v=4RXtlxE9NEw',
        'https://www.youtube.com/watch?v=Ien6ipbO9WA',
        'https://www.youtube.com/watch?v=-OO87xsyiWM',
        'https://www.youtube.com/watch?v=bcZvpBYF2zw',
        'https://www.youtube.com/watch?v=SWK4OBxNnQc',
        'https://www.youtube.com/watch?v=oQJgXCbrfI8',
        'https://www.youtube.com/watch?v=J5zAVMHRMzU'
      ],
      'Financials & Reports': [
        'https://www.youtube.com/watch?v=9puc0gmi3F0'
      ]
    }
  }
};

// Precompute "All" for each main category
const MAIN_CATEGORIES = Object.keys(TUTORIAL_DATA);
MAIN_CATEGORIES.forEach(cat => {
  const subs = TUTORIAL_DATA[cat].subcategories;
  const allVideos = [];
  Object.entries(subs).forEach(([key, urls]) => {
    if (key !== 'All' && urls) allVideos.push(...urls);
  });
  subs['All'] = allVideos;
});

const VideoCard = ({ url, onClick }) => {
  const videoId = extractVideoId(url);
  const thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;

  return (
    <Card
      className="border-0 shadow-sm hover:shadow-lg transition-all duration-200 cursor-pointer overflow-hidden group bg-white rounded-2xl"
      onClick={() => onClick(videoId)}
      data-testid={`tutorial-${videoId}`}
    >
      <div className="relative aspect-video bg-slate-100 overflow-hidden">
        <img
          src={thumbnail}
          alt="Tutorial"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-200 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg">
            <Play className="w-5 h-5 text-[#1B365D] ml-0.5" fill="#1B365D" />
          </div>
        </div>
      </div>
    </Card>
  );
};

const TutorialsTab = () => {
  const [mainCategory, setMainCategory] = useState(MAIN_CATEGORIES[0]);
  const [subCategory, setSubCategory] = useState('All');
  const [playingVideoId, setPlayingVideoId] = useState(null);

  const subcategoryNames = Object.keys(TUTORIAL_DATA[mainCategory].subcategories);
  const videos = TUTORIAL_DATA[mainCategory].subcategories[subCategory] || [];

  const handleMainCategoryChange = (cat) => {
    setMainCategory(cat);
    setSubCategory('All');
  };

  return (
    <div className="space-y-5" data-testid="tutorials-tab">
      {/* Main Category Tabs */}
      <div className="flex items-center gap-2" data-testid="tutorial-main-tabs">
        {MAIN_CATEGORIES.map(cat => {
          const isActive = mainCategory === cat;
          const count = TUTORIAL_DATA[cat].subcategories['All']?.length || 0;
          return (
            <button
              key={cat}
              onClick={() => handleMainCategoryChange(cat)}
              className={`
                px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200
                ${isActive
                  ? 'bg-[#1B365D] text-white shadow-md'
                  : 'bg-white text-slate-600 hover:bg-slate-50 border border-slate-200'
                }
              `}
              data-testid={`main-tab-${cat.toLowerCase().replace(/\s/g, '-')}`}
            >
              {cat}
              <span className={`ml-2 text-xs ${isActive ? 'text-white/70' : 'text-slate-400'}`}>{count}</span>
            </button>
          );
        })}
      </div>

      {/* Subcategory Pills */}
      <div className="flex items-center gap-2 flex-wrap" data-testid="tutorial-sub-tabs">
        {subcategoryNames.map(sub => {
          const isActive = subCategory === sub;
          const count = TUTORIAL_DATA[mainCategory].subcategories[sub]?.length || 0;
          return (
            <button
              key={sub}
              onClick={() => setSubCategory(sub)}
              className={`
                px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200
                ${isActive
                  ? 'bg-[#0071E3] text-white'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }
              `}
              data-testid={`sub-tab-${sub.toLowerCase().replace(/[\s\/]/g, '-')}`}
            >
              {sub}
              {sub !== 'All' && <span className={`ml-1.5 ${isActive ? 'text-white/70' : 'text-slate-400'}`}>{count}</span>}
            </button>
          );
        })}
      </div>

      {/* Video Count */}
      <div className="flex items-center justify-between border-b border-slate-100 pb-3">
        <h3 className="text-sm font-medium text-slate-800">
          {subCategory === 'All' ? mainCategory : subCategory}
        </h3>
        <span className="text-xs text-slate-400">{videos.length} {videos.length === 1 ? 'Video' : 'Videos'}</span>
      </div>

      {/* Video Grid */}
      <AnimatePresence mode="wait">
        <motion.div
          key={`${mainCategory}-${subCategory}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
        >
          {videos.map((url, idx) => (
            <motion.div
              key={url}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: Math.min(idx * 0.03, 0.3) }}
            >
              <VideoCard url={url} onClick={(id) => setPlayingVideoId(id)} />
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>

      {videos.length === 0 && (
        <div className="text-center py-16 text-slate-400 text-sm">No videos in this category</div>
      )}

      {/* Video Player Modal */}
      <Dialog open={!!playingVideoId} onOpenChange={() => setPlayingVideoId(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden">
          <div className="sr-only">Tutorial Video</div>
          {playingVideoId && (
            <div className="aspect-video">
              <iframe
                src={`https://www.youtube.com/embed/${playingVideoId}?autoplay=1`}
                title="Tutorial Video"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TutorialsTab;
